import { type FC } from "react";
import { Button, Switch } from "@heroui/react";
import type { HelpPoint } from "../types";
import HelpPointLocationEditor from "./HelpPointLocationEditor";

const emptyPoint = (): HelpPoint => ({
  city: "",
  address: "",
  lat: 0,
  lon: 0,
  note: "",
});

interface HelpRouteEditorProps {
  pickup: HelpPoint;
  dropoff: HelpPoint | null;
  onPickupChange: (point: HelpPoint) => void;
  onDropoffChange: (point: HelpPoint | null) => void;
  embedded?: boolean;
  mapActive?: boolean;
  onSave?: () => void;
  onCancel?: () => void;
}

const HelpRouteEditor: FC<HelpRouteEditorProps> = ({
  pickup,
  dropoff,
  onPickupChange,
  onDropoffChange,
  embedded = false,
  mapActive = true,
  onSave,
  onCancel,
}) => {
  const hasDropoff = dropoff != null;

  return (
    <div className="help-edit help-route-edit">
      <div className="help-route-edit__grid">
        <HelpPointLocationEditor
          title="Забрать"
          point={pickup}
          onChange={onPickupChange}
          mapActive={mapActive}
        />

        <div className="help-route-edit__dropoff">
          <div className="help-route-edit__dropoff-head">
            <span className="help-view-section__title">Отвезти</span>
            <Switch
              className="fbs-switch"
              isSelected={hasDropoff}
              onChange={(checked) =>
                onDropoffChange(checked ? (dropoff ?? emptyPoint()) : null)
              }
              aria-label="Нужна точка выгрузки"
            >
              <Switch.Control>
                <Switch.Thumb />
              </Switch.Control>
            </Switch>
          </div>

          {dropoff ? (
            <HelpPointLocationEditor
              title="Отвезти"
              hideTitle
              point={dropoff}
              onChange={onDropoffChange}
              mapActive={mapActive}
            />
          ) : (
            <p className="help-route-edit__empty">Точка выгрузки не указана</p>
          )}
        </div>
      </div>

      {!embedded ? (
        <div className="help-edit-actions">
          <Button size="sm" variant="tertiary" onPress={onCancel}>
            Отмена
          </Button>
          <Button size="sm" variant="primary" onPress={onSave}>
            Сохранить маршрут
          </Button>
        </div>
      ) : null}
    </div>
  );
};

export default HelpRouteEditor;
